import React, { useState } from 'react';

const FAQ = () => {
  const [openQuestion, setOpenQuestion] = useState(null);

  const faqs = [
    {
      id: 1,
      question: "What is your return policy?",
      answer: "You can return any item within 30 days of purchase if it’s unused and in the original packaging. A receipt or proof of purchase is required.",
    },
    {
      id: 2,
      question: "Do you offer international shipping?",
      answer: "Yes, we offer international shipping to many countries. Shipping costs and delivery times vary depending on the destination.",
    },
    {
      id: 3,
      question: "How can I track my order?",
      answer: "Once your order has shipped, you will receive an email with the tracking number and a link to track the package.",
    },
    {
      id: 4,
      question: "What payment methods do you accept?",
      answer: "We accept Visa, MasterCard, American Express, PayPal, and Apple Pay. Other payment methods may be available depending on your location.",
    },
  ];

  const toggleQuestion = (id) => {
    setOpenQuestion(openQuestion === id ? null : id);
  };

  return (
    <section className="bg-white py-8 dark:bg-gray-900">
      <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">Frequently Asked Questions</h2>
        <div className="mt-8 space-y-4">
          {faqs.map((faq) => (
            <div key={faq.id} className="border-b border-gray-200 dark:border-gray-700">
              <button
                className="w-full flex justify-between items-center py-4 text-left text-lg font-medium text-gray-900 dark:text-white focus:outline-none"
                onClick={() => toggleQuestion(faq.id)}
              >
                <span>{faq.question}</span>
                <svg
                  className={`w-6 h-6 transform transition-transform ${openQuestion === faq.id ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {openQuestion === faq.id && (
                <div className="pb-4 text-gray-700 dark:text-gray-400">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
